import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL?.replace(/\/$/, "") || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const buildAudioUrl = (sound) => {
  if (!sound) return "";
  if (sound.audio_url?.startsWith("http")) return sound.audio_url;
  return `${BACKEND_URL}${sound.audio_url}`;
};

export const buildLoginUrl = (role = "streamer", returnTo = null) => {
  let url = `${API}/auth/twitch/login?role=${role}`;
  if (returnTo) url += `&return_to=${encodeURIComponent(returnTo)}`;
  return url;
};

export const buildKickLoginUrl = (role = "viewer", returnTo = null) => {
  let url = `${API}/auth/kick/login?role=${role}`;
  if (returnTo) url += `&return_to=${encodeURIComponent(returnTo)}`;
  return url;
};

export const buildViewerLoginPageUrl = (returnTo = "/profile") => {
  let url = "/login";
  if (returnTo) url += `?return_to=${encodeURIComponent(returnTo)}`;
  return url;
};
